import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { fetchFinanceGroupLi } from "../../../services/Settings/dropdown";

function ucfirst(str) {
  var firstLetter = str.substr(0, 1);
  return firstLetter.toUpperCase() + str.substr(1);
}

const FinanceGroupType = ({
  control,
  name,
  onSelectChange,
  disabled,
  target,
  placeholder,
  clearable,
  showCreateOption = false,
  onCreate,
  parentChk,
  refreshKey
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [seriesData, setSeriesData] = useState([]);

  const loadOptions = async () => {
    try {
      setIsLoading(true);
      // Pass parentChk as parent_id in API params
      const data = await fetchFinanceGroupLi(parentChk);
      
      const series = data?.data?.map(dta => ({
        label: dta?.name ? ucfirst(dta.name) : '',
        value: dta.id,
        ...dta,
      }));

      // Add create option if enabled
      const options = [...series];
    if (showCreateOption && onCreate && !parentChk) {
      options.unshift({
        label: "Create ",
        value: "create_new_group",
        isCreateOption: true,
      });
    }

      setSeriesData(options);
    } catch (error) {
      console.error("Error fetching finance groups:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadOptions();
  }, [parentChk, refreshKey]);

  const handleChange = (selected, onChange) => {
    if (selected?.isCreateOption) {
      if (onCreate) {
        onCreate();
      }
      onChange(null); // Reset the select value
    } else {
      onChange(selected);
      if (onSelectChange) onSelectChange(selected);
    }
  };

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={seriesData}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select Group"} 
              </div>
            }
            isLoading={isLoading}
            isClearable={clearable}
            inputRef={ref}
            onChange={(selected) => handleChange(selected, onChange)}
            value={value}
            isDisabled={disabled}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.querySelector(target || "body")}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        )}
      />
    </div>
  );
};

export default FinanceGroupType;